@if (isVisible) {
  <div
    #controlPanel
    class="slideshow-controls"
    [class.origin-left]="originSide === 'left'"
    [class.origin-right]="originSide === 'right'"
    [class.origin-center]="originSide === 'center'"
    cdkDrag
    cdkDragBoundary=".slideshow-container"
    [cdkDragFreeDragPosition]="dragPosition"
    (cdkDragStarted)="onDragStarted()"
    (cdkDragEnded)="onDragEnded($event)"
  >
    <button mat-icon-button class="control-btn" (click)="onPrevious()">
      <mat-icon>skip_previous</mat-icon>
    </button>

    <button mat-icon-button class="control-btn play-pause-btn" (click)="togglePause()">
      <mat-icon>{{ isPaused() ? 'play_arrow' : 'pause' }}</mat-icon>
    </button>

    <button mat-icon-button class="control-btn" (click)="onNext()">
      <mat-icon>skip_next</mat-icon>
    </button>

    <div class="divider"></div>

    <button mat-icon-button class="control-btn collapse-btn" (click)="closeController()">
      <mat-icon>close</mat-icon>
    </button>

    <div class="drag-handle" cdkDragHandle>
      <mat-icon class="text-grey">drag_indicator</mat-icon>
    </div>

    <mat-progress-bar
      class="glass-progress-bar"
      [class.resetting]="progressPercentage() === 0"
      mode="determinate"
      [value]="progressPercentage()"
    >
    </mat-progress-bar>
  </div>
}

<div class="trigger-tab tab-left" (click)="openController('left')">
  <mat-icon>chevron_right</mat-icon>
</div>

<div class="trigger-tab tab-right" (click)="openController('right')">
  <mat-icon>chevron_left</mat-icon>
</div>
